import React, { useState, useEffect } from "react";

import { useTranslation } from "react-i18next";
import { isEmpty } from "lodash";

import BaseModal from "./BaseModal";
import ProductAccess from "../Product/ProductAccess";
import LookupsAPI from "../../API/lookups.api";
import OrganizationSubscriptionsAPI from "../../API/organizationSubscriptions.api";
import { ErrorAlert, SuccessAlert } from "../../utils/Alerts";
import LogCapture from "../../utils/LogManagement/LogHelper";

const ProductAccessModal = ({ isVisible, setIsVisible, selectedProduct }) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const [productAccess, setProductAccess] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);

    const [mappedUserAccesses, setMappedUserAccesses] = useState({});
    const [modifiedAccess, setModifiedAccess] = useState([]);

    const { t } = useTranslation();

    useEffect(() => {
        if (isVisible) getProductAccess();
    }, [isVisible]);

    useEffect(() => {
        formatModifiedAccess();
    }, [selectedUsers]);

    const getProductAccess = async () => {
        setIsLoading(true);
        const result = await LookupsAPI.getSubscriptionAccess(
            selectedProduct.id
        );
        setProductAccess(result);
        setIsLoading(false);
    };

    const handleSubmit = async () => {
        setIsSubmitting(true);
        const result =
            await OrganizationSubscriptionsAPI.updateSubscriptionAccess({
                organizationSubscriptionId: selectedProduct.id,
                subscriptionUserAccesses: modifiedAccess,
            });

        if (result.modified) {
            SuccessAlert(t("accessGranted"));
            LogCapture.info(
                `Subscribed product user access updated with id: ${selectedProduct?.id}`
            );
            setIsVisible(false);
        } else {
            ErrorAlert(error);
            LogCapture.error(
                `Couldn't updated subscribed product user access with id: ${selectedProduct?.id}, error: ${error}`
            );
        }
        setIsSubmitting(false);
    };

    const formatModifiedAccess = () => {
        const mappedAccess = selectedUsers.map((user) => {
            let tempUser;
            if (mappedUserAccesses[user.value.id]?.value === "Read/Write") {
                tempUser = {
                    userId: user.value.id,
                    read: true,
                    write: true,
                };
            } else {
                tempUser = {
                    userId: user.value.id,
                    read: true,
                    write: false,
                };
            }
            return user.value.isDeleted
                ? { ...tempUser, isDeleted: true }
                : { ...tempUser, isDeleted: false };
        });
        setModifiedAccess(mappedAccess);
    };

    return (
        <>
            <BaseModal
                isVisible={isVisible}
                setIsVisible={setIsVisible}
                isSubmitting={isSubmitting}
                titleIcon="fas fa-users-cog"
                title={
                    <>
                        {t("modelAccessHeader")}
                        <b>{selectedProduct?.productName}</b>
                    </>
                }
                action={{
                    submitAction: handleSubmit,
                    name: t("edit"),
                    disabled: isEmpty(modifiedAccess),
                }}
                isLoading={isLoading}
            >
                <ProductAccess
                    productAccess={productAccess}
                    selectedUsers={selectedUsers}
                    setSelectedUsers={setSelectedUsers}
                    mappedUserAccesses={mappedUserAccesses}
                    setMappedUserAccesses={setMappedUserAccesses}
                />
            </BaseModal>
        </>
    );
};

export default ProductAccessModal;
